import type { BrowserPool } from '@/types';
import { relativeTime } from '@/lib/format';
import { cn } from '@/lib/cn';

interface Props { pool: BrowserPool; }

const HEALTH_DOT: Record<BrowserPool['health'], string> = {
  healthy:  'bg-emerald-500',
  degraded: 'bg-yellow-500',
  critical: 'bg-red-500',
  unknown:  'bg-slate-500',
};

export default function PoolCard({ pool }: Props) {
  const utilization = pool.capacity > 0 ? pool.active_tabs / pool.capacity : 0;
  return (
    <div className="bg-slate-900/60 border border-slate-800 rounded-xl p-4 flex flex-col gap-3">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <span className={cn('dot', HEALTH_DOT[pool.health])} />
            <span className="font-medium truncate">{pool.display_name}</span>
          </div>
          <p className="text-[11px] text-slate-500 mt-1 truncate">{pool.id}</p>
        </div>
        <span className="text-[11px] text-slate-500 shrink-0">{pool.browser}</span>
      </div>

      <div>
        <div className="flex items-center justify-between text-xs mb-1">
          <span className="text-slate-400">utilization</span>
          <span className="font-mono">{pool.active_tabs} / {pool.capacity}</span>
        </div>
        <div className="h-1.5 bg-slate-800 rounded-full overflow-hidden">
          <div
            className={cn(
              'h-full transition-all',
              utilization > 0.9 ? 'bg-red-500'
              : utilization > 0.6 ? 'bg-yellow-500'
              : 'bg-emerald-500',
            )}
            style={{ width: `${Math.min(100, utilization * 100)}%` }}
          />
        </div>
      </div>

      <div className="text-xs text-slate-500">
        provider: <span className="font-mono text-slate-400">{pool.provider_id}</span>
        {' · '}
        updated {relativeTime(pool.updated_at)}
      </div>
    </div>
  );
}
